module.exports = __webpack_public_path__ + "img/login.3294232f.jpg";